import {useQuery} from "react-query";
import {getWalletOperations} from "../../../shared/queries";
import {useState} from "react";
import {useAppSelector} from "../../../hooks/redux";
import ModalCard from "../../common/ModalCard";
import {formatCurrency, getPaymentMethodLabel} from "../../../shared/utils";
import Modal from "../../common/Modal";
import {useTranslation} from "react-i18next";
import dayjs from "dayjs";
import {WalletOperation} from "../../../types";

export default function WalletOperations ({ isVisible, onCancel } : { isVisible: boolean, onCancel: () => void }) {

    const { t } = useTranslation();
    const currentHotelObject = useAppSelector(state => state.hotels.currentHotelObject)

    const [page, setPage] = useState(0)
    const [offset, setOffset] = useState(8)

    const { data } = useQuery(['walletOperations', page, currentHotelObject?.idAccomodation, offset], () => getWalletOperations(currentHotelObject?.idAccomodation || 0, page, offset))

    function getBackgroundColor (item: WalletOperation) {
        switch (item.paymentStatus) {
            case "PENDING":
                return 'bg-slate-200'
            case "CONFIRMED":
                return 'bg-green-600'
            case "FAILED":
                return 'bg-red-600'
            case "STARTED":
                return 'bg-slate-200'
        }
    }

    function renderAmountIcon (item: WalletOperation) {
        switch (item.paymentStatus) {
            case "PENDING":
                return <div
                    className={`${getBackgroundColor(item)} w-8 h-8 flex items-center justify-center rounded-full p-1 text-white`}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
                        <path fillRule="evenodd"
                              d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.75V6Z"
                              clipRule="evenodd"/>
                    </svg>
                </div>
            case "CONFIRMED":
                return <div
                    className={`${getBackgroundColor(item)} w-8 h-8 flex items-center justify-center rounded-full p-1 text-white`}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
                        <path fill-rule="evenodd"
                              d="M14.47 2.47a.75.75 0 0 1 1.06 0l6 6a.75.75 0 0 1 0 1.06l-6 6a.75.75 0 1 1-1.06-1.06l4.72-4.72H9a5.25 5.25 0 1 0 0 10.5h3a.75.75 0 0 1 0 1.5H9a6.75 6.75 0 0 1 0-13.5h10.19l-4.72-4.72a.75.75 0 0 1 0-1.06Z"
                              clip-rule="evenodd"/>
                    </svg>
                </div>
            case "FAILED":
                return <div
                    className={`${getBackgroundColor(item)} w-8 h-8 flex items-center justify-center rounded-full p-1 text-white`}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                             className="size-6">
                            <path fillRule="evenodd"
                                  d="M9.53 2.47a.75.75 0 0 1 0 1.06L4.81 8.25H15a6.75 6.75 0 0 1 0 13.5h-3a.75.75 0 0 1 0-1.5h3a5.25 5.25 0 1 0 0-10.5H4.81l4.72 4.72a.75.75 0 1 1-1.06 1.06l-6-6a.75.75 0 0 1 0-1.06l6-6a.75.75 0 0 1 1.06 0Z"
                                  clipRule="evenodd"/>
                        </svg>
                    </div>
                default:
                    return <div
                    className={`${getBackgroundColor(item)} w-8 h-8 flex items-center justify-center rounded-full p-1 text-white`}>
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
                        <path fillRule="evenodd"
                              d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM12.75 6a.75.75 0 0 0-1.5 0v6c0 .414.336.75.75.75h4.5a.75.75 0 0 0 0-1.5h-3.75V6Z"
                              clipRule="evenodd"/>
                    </svg>
                </div>
        }
    }

    return (
        <Modal
            visible={isVisible}>
            <ModalCard
                className={'w-full max-w-2xl'}
                title={t('wallet.operationList')}
                actionsLoading={false}>

                {
                    data?.content.map(item => {
                        return (
                            <div className={'w-full flex items-center p-4 space-x-4 border-b'}>
                                <div className={`w-8 h-8 flex items-center justify-center rounded-full p-1 text-white`}>
                                    {renderAmountIcon(item)}
                                </div>

                                <div className={'flex-1'}>
                                    <div className="flex justify-between items-center">
                                        <div className="text-lg font-semibold">{formatCurrency(item.amount)}</div>
                                        <div
                                            className={'text-slate-600'}>{dayjs(item.paymentDate).format('DD/MM/YYYY HH:mm')}</div>
                                    </div>
                                    <div className={'text-slate-600'}>{getPaymentMethodLabel(item.paymentMethod)}</div>
                                </div>
                            </div>
                        )
                    })
                }

                <nav
                    aria-label="Pagination"
                    className="flex items-center justify-between border-t border-gray-200 bg-white px-4 py-3 sm:px-6"
                >
                    <div className="hidden sm:block">
                        <p className="text-sm text-gray-700">
                            Page <span className="font-medium">{page + 1}</span> of <span className="font-medium">{data?.totalPages}</span>
                        </p>
                    </div>
                    <div className="flex flex-1 justify-between sm:justify-end">
                        <button
                            onClick={() => setPage(page - 1)}
                            className="relative inline-flex items-center rounded-md bg-white px-2 py-1 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0"
                        >
                            Previous
                        </button>
                        <button
                            onClick={() => setPage(page + 1)}
                            className="relative ml-3 inline-flex items-center rounded-md bg-white px-2 py-1 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus-visible:outline-offset-0"
                        >
                            Next
                        </button>
                    </div>
                </nav>

                <div className={'border-t p-2 flex justify-center'}>
                    <button className={'p-2 bg-orange-600 text-white px-2 py-1 rounded-md'} onClick={onCancel}>Chiudi</button>
                </div>

            </ModalCard>
        </Modal>
    )

}